/* eslint-disable */ 
import { EventStream } from 'common/types/EventStream'
import { useEffect, useRef } from 'react'

export function useEventStream<T>(
    streamCreator: () => Promise<EventStream<T>>,
    listener: (data: T) => void,
    deps: any[]
) {
    const state = useRef<{ listener?: (data: T) => void }>({})
    state.current.listener = listener
    useEffect(() => {
        let subscription: EventStream<T>
        const subscriptionPromise = streamCreator()
        let unsubscribe = false
        if (subscriptionPromise) {
            subscriptionPromise.then((newSubscription) => {
                if(newSubscription !== null) {
                    subscription = newSubscription
                    newSubscription.listen((data) => {
                        state.current.listener!(data)
                    })
                    if (unsubscribe) {
                        newSubscription.unsubscribe()
                    }
                }
            })
            return () => {
                unsubscribe = true
                subscription?.unsubscribe()
            }
        }
    }, deps)
}